export interface ListingResponse {
    success: boolean;
    description: string;
    listingId?: number;
}
